var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleBig(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 99,
    viewBox: "0 0 100 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.25 45.7286V49.5236C91.2449 58.4189 88.3646 67.0741 83.0385 74.1986C77.7124 81.3231 70.226 86.5351 61.6959 89.0572C53.1657 91.5793 44.0487 91.2764 35.7047 88.1938C27.3607 85.1111 20.2367 79.4138 15.3952 71.9515C10.5537 64.4893 8.25414 55.6619 8.83942 46.7859C9.42469 37.9099 12.8635 29.461 18.6429 22.699C24.4223 15.9371 32.2327 11.2246 40.9093 9.26421C49.5858 7.30386 58.6636 8.20075 66.7888 11.8211M91.25 16.5L50 57.7913L37.625 45.4163",
    stroke: "#303539",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleBig);
export default __webpack_public_path__ + "static/media/check_circle_big.b4c197d2c652210012879ba9fbe8b4f6.svg";
export { ForwardRef as ReactComponent };